export default __webpack_public_path__ + "static/media/Acolyte's Straps of the Black Thread.b90307cc.jpg";